import React from 'react';
import _ from 'lodash';

import {formatDate} from 'utils/datetime';
import {formatMoney} from 'utils/money';

import Table from 'components/Table';
import Button from 'components/Button';
import Paginator from 'components/Paginator';
import CreditNoteStatusTag from 'components/CreditNoteStatusTag';

import './styles.css';

const CreditNotesListTable = ({
  creditNotes,
  pagination,
  onPageChange,
  onSort,
  sort,
  redirectToScheduleItem,
  exportCreditNotesCsv
}) => {
  return (
    <div className="CreditNotesListTable">
      <div className="CreditNotesListTable__container">
        <div className="CreditNotesListTable__header">
          <Table>
            <Table.Header>
              <Table.HeaderItem
                className="tenant"
                heading="to"
                sortDirection={sort.field === 'tenant' ? sort.direction : null}
                onSort={() => onSort('tenant')}
              />
              <Table.HeaderItem
                className="schedule"
                heading="schedule"
                sortDirection={
                  sort.field === 'scheduleType' ? sort.direction : null
                }
                onSort={() => onSort('scheduleType')}
              />
              <Table.HeaderItem
                className="creditNoteNumber"
                heading="credit note no"
              />
              <Table.HeaderItem
                className="total"
                heading="total"
                sortDirection={
                  sort.field === 'totalIncludingTax' ? sort.direction : null
                }
                onSort={() => onSort('totalIncludingTax')}
              />
              <Table.HeaderItem
                className="remainingCredit"
                heading="remainingCredit"
                sortDirection={
                  sort.field === 'remainingCredit' ? sort.direction : null
                }
                onSort={() => onSort('remainingCredit')}
              />
              <Table.HeaderItem className="status" heading="status" />
              <Table.HeaderItem
                className="dateIssued"
                heading="issue date"
                sortDirection={
                  sort.field === 'dateIssued' ? sort.direction : null
                }
                onSort={() => onSort('dateIssued')}
              />
              <Table.HeaderItem
                className="rentStart"
                heading="rent start"
                sortDirection={
                  sort.field === 'rentStart' ? sort.direction : null
                }
                onSort={() => onSort('rentStart')}
              />
              <Table.HeaderItem
                className="rentEnd"
                heading="rent end"
                sortDirection={sort.field === 'rentEnd' ? sort.direction : null}
                onSort={() => onSort('rentEnd')}
              />
              <Table.HeaderItem
                className="dateCreated"
                heading="date created"
                sortDirection={
                  sort.field === 'createdAt' ? sort.direction : null
                }
                onSort={() => onSort('createdAt')}
              />
              <Table.HeaderItem className="createdBy" heading="created by" />
              <Table.HeaderItem className="voidedBy" heading="voided by" />
              <Table.HeaderItem className="xeroLink" heading="xero link" />
            </Table.Header>
          </Table>
        </div>
        <div className="CreditNotesListTable__content">
          <Table>
            <Table.Body>
              {creditNotes.map(creditNote => (
                <Table.Row key={creditNote.id}>
                  <Table.Cell className="tenant">
                    {creditNote.primaryTenant}
                  </Table.Cell>
                  <Table.Cell className="schedule">
                    {creditNote.scheduleType}
                  </Table.Cell>
                  <Table.Cell className="creditNoteNumber">
                    <div
                      className="colab-clickable colab-link"
                      onClick={() =>
                        redirectToScheduleItem({
                          link: creditNote.detailLink
                        })
                      }>
                      {creditNote.idString}
                    </div>
                  </Table.Cell>
                  <Table.Cell className="total">
                    £{formatMoney(creditNote.totalIncludingTax)}
                  </Table.Cell>
                  <Table.Cell className="remainingCredit">
                    £{formatMoney(creditNote.remainingCredit)}
                  </Table.Cell>
                  <Table.Cell className="status">
                    <CreditNoteStatusTag
                      label={creditNote.verboseStatus.label}
                      status={creditNote.verboseStatus.status}
                    />
                  </Table.Cell>
                  <Table.Cell className="dateIssued">
                    {formatDate(creditNote.dateIssued)}
                  </Table.Cell>
                  <Table.Cell className="rentStart">
                    {!_.isNil(creditNote.rentStart)
                      ? formatDate(creditNote.rentStart)
                      : ' - '}
                  </Table.Cell>
                  <Table.Cell className="rentEnd">
                    {!_.isNil(creditNote.rentEnd)
                      ? formatDate(creditNote.rentEnd)
                      : ' - '}
                  </Table.Cell>
                  <Table.Cell className="dateCreated">
                    {formatDate(creditNote.createdAt)}
                  </Table.Cell>
                  <Table.Cell className="createdBy">
                    {creditNote.createdBy}
                  </Table.Cell>
                  <Table.Cell className="voidedBy">
                    {_.get(creditNote, 'voidedBy', '-')}
                  </Table.Cell>
                  <Table.Cell className="xeroLink">
                    {creditNote.xeroId ? (
                      <div
                        className="colab-clickable colab-link"
                        onClick={() =>
                          redirectToScheduleItem({link: creditNote.xeroLink})
                        }>
                        {creditNote.xeroNumber} →
                      </div>
                    ) : (
                      <CreditNoteStatusTag
                        status={CreditNoteStatusTag.NOT_SYNCED}
                        label={CreditNoteStatusTag.NOT_SYNCED}
                      />
                    )}
                  </Table.Cell>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </div>
      </div>
      <Paginator
        pagination={pagination}
        onPageChange={onPageChange}
        ActionsComponent={() => (
          <div>
            <Button
              white
              className="exportButton"
              onClick={exportCreditNotesCsv}>
              Export Credit Notes
            </Button>
          </div>
        )}
      />
    </div>
  );
};

export default CreditNotesListTable;
